import Link from "next/link";
import React, { useState } from "react";
import { motion } from "framer-motion";
import Image from "next/image";

export function Logo() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link href="/" className="inline-block">
      <motion.div
        className="flex items-center transition-all duration-300 hover:scale-105 hover:rotate-1 active:scale-95 active:rotate-0"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.1 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onTouchStart={() => setIsHovered(true)}
        onTouchEnd={() => setIsHovered(false)}
      >
        {isHovered ? (
          <Image
            src="/lk-colored.svg"
            alt="LK Media Logo"
            width={32}
            height={32}
            priority
          />
        ) : (
          <div className="relative w-8 h-8">
            <Image
              src="/lkmedia-logo.svg"
              alt="LK Media Logo"
              width={32}
              height={32}
              priority
              className="dark:invert"
            />
          </div>
        )}
      </motion.div>
    </Link>
  );
}
